/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedNumberPool } from './ParsedNumberPool';
import {
    ParsedNumberPoolFromJSON,
    ParsedNumberPoolFromJSONTyped,
    ParsedNumberPoolToJSON,
} from './ParsedNumberPool';
import type { AddonSelection } from './AddonSelection';
import {
    AddonSelectionFromJSON,
    AddonSelectionFromJSONTyped,
    AddonSelectionToJSON,
} from './AddonSelection';

/**
 * Player picks for a single panel:
 *   - `numberSelections`: the primary (PRIMARY_WINNING) pool picks. Legacy field retained because the shipped
 *     ticket-scan API + /record contract exposes it and external clients (e.g. MI) depend on it; equals the
 *     PRIMARY_WINNING entry in `pools`.
 *   - `secondarySelection`: the non-primary pool picks (secondary/bonus), when the game has a second pool.
 *     Legacy field, same contract reason.
 *   - `pools`: the panel's number pools, ordered for display (per the game's numberGroupDisplayOrder, e.g.
 *     2by2 emits its bonus pool first). Optional/additive; consumers render pools in array order.
 *   - `addonSelection`: RAPID only - selected add-ons (multiplier, extra-draws, mini-game like jack).
 * @export
 * @interface ParsedDrawPanel
 */
export interface ParsedDrawPanel {
    /**
     * RAPID only: selected add-ons (multiplier, extra-draws, mini-game like jack).
     * @type {AddonSelection}
     * @memberof ParsedDrawPanel
     */
    addonSelection?: AddonSelection | null;
    /**
     * 
     * @type {Array<ParsedNumberPool>}
     * @memberof ParsedDrawPanel
     */
    pools?: Array<ParsedNumberPool> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ParsedDrawPanel
     */
    secondarySelection?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ParsedDrawPanel
     */
    numberSelections: Array<number>;
}

/**
 * Check if a given object implements the ParsedDrawPanel interface.
 */
export function instanceOfParsedDrawPanel(value: object): value is ParsedDrawPanel {
    if (!('numberSelections' in value) || value['numberSelections'] === undefined) return false;
    return true;
}

export function ParsedDrawPanelFromJSON(json: any): ParsedDrawPanel {
    return ParsedDrawPanelFromJSONTyped(json, false);
}

export function ParsedDrawPanelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedDrawPanel {
    if (json == null) {
        return json;
    }
    return {
        
        'addonSelection': json['addonSelection'] == null ? undefined : AddonSelectionFromJSON(json['addonSelection']),
        'pools': json['pools'] == null ? undefined : ((json['pools'] as Array<any>).map(ParsedNumberPoolFromJSON)),
        'secondarySelection': json['secondarySelection'] == null ? undefined : json['secondarySelection'],
        'numberSelections': json['numberSelections'],
    };
}

export function ParsedDrawPanelToJSON(value?: ParsedDrawPanel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'addonSelection': AddonSelectionToJSON(value['addonSelection']),
        'pools': value['pools'] == null ? undefined : ((value['pools'] as Array<any>).map(ParsedNumberPoolToJSON)),
        'secondarySelection': value['secondarySelection'],
        'numberSelections': value['numberSelections'],
    };
}

